import _ from 'lodash';
import moment from 'moment';
import globalStore from '$$globalStore';
import globalToast from '$$vueCmp/toast';
import constants from '$$helpers/constants';
import customHelper from '$$helpers/custom';
import dateHelper from '$$dateFormatsHelper';
import getValueForUserColumn from './getValueForUserColumn';

export default function (task, columnId, val) {
  const column = globalStore.getters['columns/getCustomColumnById'](columnId);

  if (!column) {
    return false;
  }

  const isOptions = !!(column.options && column.options.length);
  let value = val;

  if (column.type === constants.CUSTOM_COLUMNS_TYPES.number.id) {
    if (!customHelper.testNumber(value)) {
      globalToast.warning(__('grid_number_custom_column_not_valid'));

      return false;
    }

    value = value.toString().replace(',', '.');
  }

  if (column.type === constants.CUSTOM_COLUMNS_TYPES.date.id) {
    const isEmpty = value === '';
    const isValid = value instanceof Date && !_.isNaN(value);

    if (!isValid && !isEmpty) {
      globalToast.warning(__('gantt_date_invalid'));

      return false;
    }

    value = dateHelper.checkIfDateInLimit(value, true);
    value = value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : null;
  }

  if (column.type === constants.CUSTOM_COLUMNS_TYPES.text.id) {
    value = customHelper.removeSpaces(value);

    if (value.length > 2048) {
      value = value.substr(0, 2047);
      globalToast.warning(__('msg_custom_column_long_text'));
    }
  }

  if (column.type === constants.CUSTOM_COLUMNS_TYPES.checkbox.id) {
    const oldValue = +getValueForUserColumn(task, column).value;

    value = +!oldValue;
  }

  let newValues = value;

  if (isOptions) {
    newValues = value ? value.split(',') : [];
  }

  const tasksToUpdate = [{ id: task.id, customFields: [{ customColumnId: column.id, value: newValues, isOptions }] }];

  globalStore.dispatch('tasksModel/updateTasks', {
    tasks: tasksToUpdate,
    sourceEvent: {
      type: constants.GANTT_SOURCE_EVENT_TYPES.CUSTOM_FIELDS_UPDATE,
      sourceId: task.id,
    },
    fromGantt: false,
  });
}
